<script>
  import conciliacaoProjetoServico from '../servico';
  import moment from 'moment';

  import $ from 'jquery';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';

  import ConfiguracaoCreditoModal from './ConfiguracaoCreditoModal.vue';
  import CreditosIdentificadosLista from './CreditosIdentificadosLista.vue';
  import AplicacoesContaModal from './AplicacoesContaModal.vue';
  import PosicaoTesourariaDetalhe from './PosicaoTesourariaDetalhe.vue';
  import TarifasBorderoModal from './TarifasBorderoModal.vue';
  import RateioPlanilhaModal from './RateioPlanilhaModal.vue';
  import AcompanhamentoEnvioModal from './AcompanhamentoEnvioModal.vue';
  import permissoesConciliacao from '~js/permissoes-conciliacao';

  const TIPOS_ARQUIVO_EXTRATO = [
    { chave: 'pdf', rotulo: 'PDF', plural: 'PDFs' },
    { chave: 'excel', rotulo: 'EXCEL', plural: 'Excel' },
    { chave: 'ofx', rotulo: 'OFX', plural: 'OFX' }
  ];

  export default {
    components: { ConfiguracaoCreditoModal, CreditosIdentificadosLista, AplicacoesContaModal, PosicaoTesourariaDetalhe, TarifasBorderoModal, RateioPlanilhaModal, AcompanhamentoEnvioModal },
    data() {
      return {
        qtdeDiferenca: null,
        qtdeOperacao: null,
        chaveDiferenca: '',
        ultimaAtualizacao: '',
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        registros: [],
        resumo: this.resumoVazio(),
        dataReferenciaTesouraria: '',
        listaContas: [],
        bancos: [],
        contasStatus: [],
        possuiRestricaoResponsavel: false,
        todos: false,
        aplicacoesConta: null,
        contaDetalhe: '',
        carregando: true,
        animated: true,
        filtros: this.carregarFiltros(),
        timerFiltro: null,
        mostrarEnvioContas: false,
        jobEnvio: '',
        mostrarAcompanhamento: false,
        progressoEnvio: null,
        destacarEnvio: false,
        envioFlash: '',
        envioFlashResumo: '',
        timerFlash: null,
        mostrarConfiguracao: false,
        mostrarIgnoradas: false,
        mostrarTarifas: false,
        mostrarRateioPlanilha: false,
        menuPasso2: false,
        exportando: false,
        carregandoContasLista: false,
        enviandoContas: false,
        contasUploads: [],
        arquivosContasMarcados: {},
        pendentesEnvio: null,
        isaacConfigurado: true,
        motivoIsaac: '',
        mostrarProcessamento: false,
        carregandoPrevia: false,
        sugestoesAplicacao: [],
        gravandoSugestao: '',
        processando: false,
        previa: this.previaVazia(),
        contasProcessadas: 0,
        conciliadosProcesso: 0,
        aplicacoesProcesso: 0,
        resgatesProcesso: 0,
        falhasProcesso: 0,
        avisosProcesso: [],
        paresDesfeitosProcesso: [],
      }
    },
    computed: {
      paginas() {
        const total = this.totalPaginas || 1;
        const atual = this.pagina || 1;
        const ini = Math.max(1, Math.min(atual - 2, total - 4));
        const fim = Math.min(total, ini + 4);
        const lista = [];
        for (let p = ini; p <= fim; p++) lista.push(p);
        return lista;
      },
      infoPaginacao() {
        const total = this.totalRegistros || 0;
        if (!total) return '';
        const por = this.registrosPorPagina || total;
        const ini = (this.pagina - 1) * por + 1;
        const fim = Math.min(total, ini + por - 1);
        return ini + '–' + fim + ' de ' + total + (total === 1 ? ' conta' : ' contas');
      },
      podeAlterar() { return permissoesConciliacao.alterar('banco'); },
      podeConfigurar() { return permissoesConciliacao.configurar('banco'); },
      podeTesouraria() { return permissoesConciliacao.consultar('tesouraria'); },
      podeTratarTesouraria() { return permissoesConciliacao.alterar('tesouraria'); },
      indice() { return (this.resumo.indiceConciliacao || 0).toString().replace('.', ','); },
      pctConciliadas() {
        return this.resumo.totalConciliacoes ? Math.round(this.resumo.conciliadas / this.resumo.totalConciliacoes * 100) : 0;
      },
      pctNaoConciliadas() {
        return this.resumo.totalConciliacoes ? Math.round(this.resumo.naoConciliadas / this.resumo.totalConciliacoes * 100) : 0;
      },
      pctDiferenca() {
        return this.resumo.totalConciliacoes && this.qtdeDiferenca ? Math.round(this.qtdeDiferenca / this.resumo.totalConciliacoes * 100) : 0;
      },
      pctOperacao() {
        return this.resumo.totalConciliacoes && this.qtdeOperacao ? Math.round(this.qtdeOperacao / this.resumo.totalConciliacoes * 100) : 0;
      },
      pendentes() { return Math.max(0, (this.resumo.totalConciliacoes || 0) - (this.resumo.conciliadas || 0)); },
      temFiltro() {
        return this.filtros.status !== '0' || this.filtros.situacaoConta !== '0' || !!this.filtros.idConta
            || !!this.filtros.banco || this.filtros.comExtrato || !!this.filtros.ordem;
      },
      contasDoBanco() {
        const banco = this.filtros.banco;
        const doStatus = this.filtros.status !== '0';
        return this.listaContas.filter(c => (!banco || c.nomeBanco === banco)
          && (!doStatus || c.idContaCript === this.filtros.idConta || this.contasStatus.indexOf(c.nomeConta) >= 0));
      },
      bancosOpcoes() {
        const banco = this.filtros.banco;
        return banco && this.bancos.indexOf(banco) < 0 ? this.bancos.concat([banco]).sort() : this.bancos;
      },
      descricaoSituacao() {
        const situacao = this.filtros.situacaoConta === '1' ? 'só encerradas' : this.filtros.situacaoConta === '2' ? 'ativas + encerradas' : 'só ativas';
        return this.filtros.banco ? this.nomeCurtoBanco(this.filtros.banco) + ' · ' + situacao : situacao;
      },
      atualizando() { return this.carregando || this.qtdeDiferenca === null; },
      chipsRecorte() {
        const f = this.filtros;
        const chips = [];
        const status = { '1': ['Conciliadas', 'rec-ok'], '2': ['Extrato pendente', 'rec-nunca'], '4': ['Com diferença', 'rec-andamento'], '5': ['Em conciliação', 'rec-operacao'] }[f.status];
        if (status) chips.push({ chave: 'status', rotulo: status[0], classe: status[1], remover: () => this.filtrarStatus('0') });
        if (f.banco) chips.push({ chave: 'banco', rotulo: f.banco, estilo: this.corBanco(f.banco), remover: () => { f.banco = ''; } });
        if (f.idConta) chips.push({ chave: 'conta', rotulo: f.nomeConta || 'Conta selecionada', icone: 'fa-bank', remover: () => { f.idConta = ''; f.nomeConta = ''; } });
        if (f.situacaoConta !== '0') chips.push({ chave: 'situacao', rotulo: f.situacaoConta === '1' ? 'Encerradas' : 'Ativas + encerradas', remover: () => { f.situacaoConta = '0'; } });
        if (f.comExtrato) chips.push({ chave: 'extrato', rotulo: 'Com extrato bancário', remover: () => { f.comExtrato = false; } });
        if (f.ordem) chips.push({ chave: 'ordem', rotulo: 'Ordem: ' + this.rotuloOrdem, icone: 'fa-sort-amount-desc', remover: () => { f.ordem = ''; } });
        return chips;
      },
      rotuloOrdem() {
        return {
          'extrato': 'Extrato mais antigo',
          'extrato-menos': 'Reta final',
          'extrato-mais': 'Mutirão',
          'pendencias': 'Mais itens pendentes',
          'percentual': 'Menor % conciliado',
          'conta': 'Conta (A–Z)',
          'diferenca-maior': 'Maior diferença',
        }[this.filtros.ordem] || this.filtros.ordem;
      },
      qtdContasMarc() { return this.contasUploads.filter(a => this.arquivosContasMarcados[a.nome]).length; },
      todosContasMarc() { return this.contasUploads.length > 0 && this.contasUploads.every(a => this.arquivosContasMarcados[a.nome]); },
      estiloBotaoEnvio() {
        const pct = this.progressoEnvio ? +this.progressoEnvio.percentual || 0 : 2;
        return { backgroundImage: `linear-gradient(to right, #d3f1e9 ${pct}%, #ffffff ${pct}%)` };
      },
      gruposContas() {
        const grupos = [];
        const porChave = {};
        this.contasUploads.forEach(a => {
          const barra = a.nome.indexOf('/');
          const chave = barra > 0 ? a.nome.substring(0, barra) : '';
          if (!porChave[chave]) { porChave[chave] = { chave, arquivos: [] }; grupos.push(porChave[chave]); }
          porChave[chave].arquivos.push({ arquivo: a, rotulo: barra > 0 ? a.nome.substring(barra + 1) : a.nome, tipo: this.tipoArquivoExtrato(a.nome) });
        });
        grupos.forEach(g => { g.tipos = this.separarPorTipo(g.arquivos); });
        return grupos.sort((x, y) => (x.chave === '' ? 1 : y.chave === '' ? -1 : x.chave.localeCompare(y.chave)));
      },
      textoEnvioPendentes() {
        if (!this.isaacConfigurado) return 'Isaac Hub não configurado';
        if (this.pendentesEnvio === null) return 'verificando a pasta...';
        if (this.pendentesEnvio < 0) return 'pasta nao verificada';
        if (this.pendentesEnvio === 0) return 'nenhum arquivo novo';
        return this.pendentesEnvio + (this.pendentesEnvio > 1 ? ' arquivos novos' : ' arquivo novo');
      },
    },
    mounted() {
      this.$root.tituloDaPagina = 'Conciliação de Banco';

      const _this = this;
      $('#contaFiltro').select2({ theme: 'bootstrap', placeholder: '🔍  Digite para buscar uma conta...', allowClear: true, language: 'pt-BR', minimumInputLength: 0 })
        .change(function () {
          _this.$set(_this.filtros, 'idConta', this.value || '');
          const conta = _this.listaContas.filter(c => c.idContaCript === this.value)[0];
          _this.$set(_this.filtros, 'nomeConta', conta ? conta.nomeConta : '');
        });

      this.carregarContas();

      if (this.$route.query.envio === '1') this.abrirEnvioContas();
    },
    methods: {
      resumoVazio() { return { totalConciliacoes: 0, conciliadas: 0, emConciliacao: 0, naoConciliadas: 0, indiceConciliacao: 0 }; },
      camposFiltros() { return { status: '0', situacaoConta: '0', idConta: '', nomeConta: '', buscaConta: '', banco: '', comExtrato: false, ordem: '' }; },
      filtrarStatus(status) { this.$set(this.filtros, 'status', this.filtros.status === status && status !== '0' ? '0' : status); },
      carregarFiltros() {
        try {
          const s = sessionStorage.getItem('conc-banco-filtros');
          const base = s ? Object.assign(this.camposFiltros(), JSON.parse(s)) : this.camposFiltros();
          if (this.$route.query.extrato !== undefined) base.soExtratoPendente = this.$route.query.extrato === '1';
          if (base.soExtratoPendente) base.status = '2';
          delete base.soExtratoPendente;
          return base;
        } catch (e) { return this.camposFiltros(); }
      },
      salvarFiltros() {
        try { sessionStorage.setItem('conc-banco-filtros', JSON.stringify(this.filtros)); } catch (e) { }
      },
      montarFiltros() {
        return {
          status: this.filtros.status,
          situacaoConta: this.filtros.situacaoConta,
          idConta: this.filtros.idConta || '',
          buscaConta: this.filtros.buscaConta || '',
          banco: this.filtros.banco || '',
          comExtrato: this.filtros.comExtrato || false,
          ordem: this.filtros.ordem || '',
        };
      },
      carregarContas() {
        return conciliacaoProjetoServico.contas(this.todos).then(c => { this.listaContas = c; });
      },
      sincronizarSelectConta() {
        const el = $('#contaFiltro');
        if (!el.length) return;

        this.recuperarContaSalva();

        el.val(this.filtros.idConta || '').trigger('change.select2');
      },
      recuperarContaSalva() {
        const valor = this.filtros.idConta || '';
        if (!valor || this.listaContas.length === 0) return;
        if (this.listaContas.some(c => c.idContaCript === valor)) return;

        const conta = this.listaContas.filter(c => c.nomeConta === this.filtros.nomeConta)[0];

        this.$set(this.filtros, 'idConta', conta ? conta.idContaCript : '');
        if (!conta) this.$set(this.filtros, 'nomeConta', '');
      },
      lista(pagina = 1) {
        this.carregando = true;
        this.registros = [];
        this.pagina = pagina;
        this.carregarDiferenca();
        return conciliacaoProjetoServico.listaBanco(pagina, this.montarFiltros(), this.todos)
          .then(dados => {
            this.carregando = false;
            this.registros = dados.registros || [];
            this.totalRegistros = dados.totalRegistros;
            this.totalPaginas = dados.totalPaginas;
            this.registrosPorPagina = dados.registrosPorPagina;
            this.resumo = dados.resumo || this.resumoVazio();
            this.dataReferenciaTesouraria = dados.dataReferenciaTesourariaCurta || '';
            this.bancos = dados.bancos || [];
            this.contasStatus = dados.contas || [];
            this.possuiRestricaoResponsavel = dados.possuiRestricaoResponsavel;
            this.ultimaAtualizacao = moment().format('HH:mm');
          })
          .catch(() => { this.carregando = false; toastr.error('Não foi possível carregar as conciliações.'); });
      },
      carregarDiferenca() {
        const filtros = {
          situacaoConta: this.filtros.situacaoConta,
          comExtrato: this.filtros.comExtrato || false,
          idConta: this.filtros.idConta || '',
          buscaConta: this.filtros.buscaConta || '',
          banco: this.filtros.banco || '',
        };
        const chave = JSON.stringify(filtros);
        if (chave === this.chaveDiferenca) return;
        this.chaveDiferenca = chave;
        this.qtdeDiferenca = null;
        this.qtdeOperacao = null;
        conciliacaoProjetoServico.comDiferencaBanco(filtros)
          .then(dados => {
            if (this.chaveDiferenca !== chave) return;
            this.qtdeDiferenca = dados.qtde || 0;
            this.qtdeOperacao = dados.qtdeOperacao || 0;
          })
          .catch(() => { if (this.chaveDiferenca === chave) { this.chaveDiferenca = ''; this.qtdeDiferenca = 0; this.qtdeOperacao = 0; } });
      },
      atualizar() {
        if (this.atualizando) return;
        this.chaveDiferenca = '';
        this.lista(this.pagina);
        if (this.podeAlterar) this.carregarPendentesEnvio();
      },
      agendarLista() {
        clearTimeout(this.timerFiltro);
        this.timerFiltro = setTimeout(() => this.lista(1), 250);
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => this.sincronizarSelectConta());
        this.agendarLista();
      },
      alternarTodos() { this.todos = !this.todos; this.carregarContas(); this.limparFiltros(); },
      irPagina(p) {
        if (p < 1 || p > this.totalPaginas || p === this.pagina) return;
        this.lista(p).then(() => this.$nextTick(() => { if (this.$refs.corpo) this.$refs.corpo.scrollTop = 0; }));
      },
      abrirConciliacao(conta) {
        this.$router.push({ name: 'conciliacao-banco.tela', params: { idContaCript: conta.idContaCript } });
      },
      previaVazia() {
        return { contas: 0, extratosPendentes: 0, extratosAConferir: 0, contasSoAConferir: 0, contasAplicacaoUnica: 0, automacaoAplicacaoResgate: false, dataCorte: '' };
      },
      abrirProcessamento() {
        this.mostrarProcessamento = true;
        this.zerarProcesso();
        this.carregarPrevia();
      },
      zerarProcesso() {
        this.contasProcessadas = 0;
        this.conciliadosProcesso = 0;
        this.aplicacoesProcesso = 0;
        this.resgatesProcesso = 0;
        this.falhasProcesso = 0;
        this.avisosProcesso = [];
        this.paresDesfeitosProcesso = [];
      },
      carregarPrevia() {
        this.carregandoPrevia = true;
        this.previa = this.previaVazia();

        conciliacaoProjetoServico.previaProcessamentoBanco()
          .then(dados => { this.previa = dados || this.previa; this.carregandoPrevia = false; })
          .catch(() => { this.carregandoPrevia = false; toastr.error('Não foi possível carregar os dados do processamento.'); });
        this.carregarSugestoesAplicacao();
      },
      carregarSugestoesAplicacao() {
        conciliacaoProjetoServico.sugestoesTextoAplicacao()
          .then(lista => { this.sugestoesAplicacao = (lista || []).map(s => Object.assign({ original: s.texto }, s)); })
          .catch(() => { this.sugestoesAplicacao = []; });
      },
      decidirSugestao(s, confirmar) {
        const texto = (s.texto || '').trim();
        if (confirmar && texto.length < 4) { toastr.warning('O texto precisa ter ao menos 4 caracteres.'); return; }
        this.gravandoSugestao = s.original;
        const chamada = confirmar
          ? conciliacaoProjetoServico.confirmarTextosAplicacao([texto])
          : conciliacaoProjetoServico.rejeitarTextosAplicacao([s.original]);
        chamada
          .then(() => {
            this.gravandoSugestao = '';
            toastr.success(confirmar ? 'Texto cadastrado em aplicação e resgate.' : 'Sugestão rejeitada — não aparece mais.');
            this.carregarSugestoesAplicacao();
          })
          .catch(res => {
            this.gravandoSugestao = '';
            toastr.error(res && res.body && res.body.message ? res.body.message : 'Não foi possível gravar.');
          });
      },
      resumoSugestao(s) {
        const partes = [s.qtde + (s.qtde === 1 ? ' linha' : ' linhas')];
        if (s.contas > 1) partes.push('em ' + s.contas + ' contas');
        if (s.debitos && !s.creditos) partes.push('débitos (aplicação)');
        else if (s.creditos && !s.debitos) partes.push('créditos (resgate)');
        return partes.join(' · ');
      },
      fecharProcessamento() {
        if (this.processando) return;
        this.mostrarProcessamento = false;
      },
      dataCorteTexto() {
        if (!this.previa.dataCorte) return 'sem data de corte';
        return moment(this.previa.dataCorte, 'YYYY-MM-DD').format('DD/MM/YYYY');
      },
      processarContas() {
        if (this.processando) return;
        this.processando = true;
        this.zerarProcesso();
        this.processarLote(0);
      },
      processarLote(cursor) {
        conciliacaoProjetoServico.processarBanco(cursor)
          .then(dados => {
            this.contasProcessadas += (dados && dados.contas) || 0;
            this.conciliadosProcesso += (dados && dados.conciliados) || 0;
            this.aplicacoesProcesso += (dados && dados.aplicacoes) || 0;
            this.resgatesProcesso += (dados && dados.resgates) || 0;
            this.falhasProcesso += (dados && dados.falhas) || 0;

            const avisos = (dados && dados.avisos) || [];
            if (avisos.length > 0) this.avisosProcesso = this.avisosProcesso.concat(avisos).slice(0, 50);

            const desfeitos = (dados && dados.paresDesfeitos) || [];
            if (desfeitos.length > 0) this.paresDesfeitosProcesso = this.paresDesfeitosProcesso.concat(desfeitos).slice(0, 100);

            if (dados && !dados.concluido) {
              this.processarLote(dados.cursor);
              return;
            }

            this.processando = false;
            if (this.avisosProcesso.length === 0 && this.paresDesfeitosProcesso.length === 0) this.mostrarProcessamento = false;

            const lancados = this.aplicacoesProcesso + this.resgatesProcesso;

            if (this.conciliadosProcesso > 0 || lancados > 0) {
              toastr.success(this.numero(this.conciliadosProcesso) + ' item(ns) conciliados'
                + (lancados > 0 ? ' e ' + this.numero(lancados) + ' aplicação/resgate lançados' : '')
                + ' em ' + this.numero(this.contasProcessadas) + ' conta(s).');
            } else {
              toastr.info('Nada novo para conciliar nas contas com extrato pendente.');
            }

            this.lista(this.pagina);
          })
          .catch(res => {
            this.processando = false;
            toastr.error(res && res.body && res.body.message ? res.body.message : 'Não foi possível processar as contas.');
            if (this.contasProcessadas > 0) this.lista(this.pagina);
          });
      },
      abrirConfiguracao() { this.mostrarConfiguracao = true; },
      abrirTesouraria() { this.$router.push({ name: 'posicao-tesouraria' }); },
      abrirIgnoradas() { this.menuPasso2 = false; this.mostrarIgnoradas = true; },
      fecharIgnoradas() { this.mostrarIgnoradas = false; },
      abrirTarifas() { this.menuPasso2 = false; this.mostrarTarifas = true; },
      aoGerarTarifas() { this.lista(this.pagina); },
      abrirRateioPlanilha() { this.menuPasso2 = false; this.mostrarRateioPlanilha = true; },
      exportar() {
        if (this.exportando) return;
        this.exportando = true;
        conciliacaoProjetoServico.exportarListaBanco(this.montarFiltros(), this.todos)
          .then(registros => {
            this.exportando = false;
            this.gerarCsv(registros || []);
          })
          .catch(() => {
            this.exportando = false;
            toastr.error('Não foi possível gerar o Excel.');
          });
      },
      gerarCsv(registros) {
        const num = v => (v === null || v === undefined ? '' : (+v).toFixed(2).replace('.', ','));
        const txt = v => '"' + ('' + (v === null || v === undefined ? '' : v)).replace(/"/g, '""') + '"';
        const ref = this.dataReferenciaTesouraria || '';
        const cab = ['Conta', 'Nº banco', 'Banco', 'Situação da conta', 'Conciliado no Manager' + (ref ? ' em ' + ref : ''), 'Operação no Manager', 'Extrato (banco)', 'Data do saldo do banco',
          'Diferença', 'Tipo da diferença', 'Status', 'Pendências (itens)', 'Conclusão %', 'Conciliados', 'Total de itens', 'Extratos pendentes', 'Última atualização', 'Usuário'];
        const linhas = [cab.map(txt).join(';')];
        registros.forEach(r => {
          const t = r.tesouraria || {};
          const temBanco = this.temBanco(r.tesouraria);
          linhas.push([
            txt(r.nomeConta), txt(r.numeroBanco), txt(r.nomeBanco), txt(r.encerrada ? 'encerrada' : 'ativa'),
            num(t.saldoConciliado), num(t.saldoOperacao), temBanco ? num(t.saldoBanco) : txt(''), txt(temBanco ? t.dataSaldoBancoTexto : ''),
            temBanco ? num(t.divergencia) : txt(''), txt(temBanco ? (t.tipoDivergencia || '') : ''),
            txt(this.situacao(r).label), txt(this.iniciou(r) ? this.pendencias(r) : ''), txt(r.percentualConclusao), txt(r.lancamentosConciliados), txt(r.totalLancamentos),
            txt(r.extratosPendentes || 0), txt(r.ultimaAtualizacao || ''), txt(r.usuarioUltimaAtualizacao || ''),
          ].join(';'));
        });
        const blob = new Blob(['﻿' + linhas.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'conciliacao-banco-' + moment().format('DD-MM-YYYY') + '.csv';
        link.click();
        URL.revokeObjectURL(url);
      },
      fecharConfiguracao() { this.mostrarConfiguracao = false; },
      aoSalvarConfiguracao() {
        this.mostrarConfiguracao = false;
        this.carregarContas();
        this.lista(this.pagina);
      },
      carregarPendentesEnvio() {
        return conciliacaoProjetoServico.extratoContasResumo()
          .then(dados => {
            this.pendentesEnvio = +((dados && dados.pendentes) || 0);
            this.isaacConfigurado = !(dados && dados.isaacConfigurado === false);
            this.motivoIsaac = (dados && dados.motivoIsaac) || '';
          })
          .catch(() => { this.pendentesEnvio = -1; });
      },
      abrirEnvioContas() {
        this.mostrarEnvioContas = true; this.contasUploads = []; this.arquivosContasMarcados = {}; this.carregandoContasLista = true;
        conciliacaoProjetoServico.extratoContasLista()
          .then(dados => {
            this.carregandoContasLista = false;
            this.isaacConfigurado = dados.isaacConfigurado;
            this.motivoIsaac = dados.motivoIsaac || '';
            this.contasUploads = dados.arquivos || [];
            this.pendentesEnvio = this.contasUploads.length;
            const marc = {}; this.contasUploads.forEach(a => { marc[a.nome] = false; }); this.arquivosContasMarcados = marc;
          })
          .catch(() => { this.carregandoContasLista = false; toastr.error('Não foi possível listar os extratos de contas.'); });
      },
      fecharEnvioContas() { this.mostrarEnvioContas = false; },
      marcarTodosContas(val) { const m = {}; this.contasUploads.forEach(a => { m[a.nome] = val; }); this.arquivosContasMarcados = m; },
      marcaBanco(nome, numero) {
        const n = (nome || '').toLowerCase().replace(/ú/g, 'u');
        const cod = ('000' + String(numero || '').replace(/\D/g, '')).slice(-3);
        const marcas = [
          [/banco do brasil|^bb$/, '001', 'BB', '#e6c800', '#2a4a8a'],
          [/itau/, '341', 'Itaú', '#ec7000', '#b35500'],
          [/santander/, '033', 'Santander', '#cc0000', '#a31515'],
          [/bradesco/, '237', 'Bradesco', '#cc092f', '#a3122e'],
          [/caixa|cef/, '104', 'Caixa', '#005ca9', '#1d5a94'],
          [/sicoob/, '756', 'Sicoob', '#00838f', '#1f5f66'],
          [/sicredi/, '748', 'Sicredi', '#3fa110', '#3a7a1e'],
          [/^(banco )?inter$/, '077', 'Inter', '#ff7a00', '#b35a10'],
          [/nubank|nu pag/, '260', 'Nubank', '#820ad1', '#6b2ba3'],
          [/mercado ?pago/, '323', 'Mercado Pago', '#00b1ea', '#1a7fa3'],
          [/paypal/, '', 'PayPal', '#003087', '#2b4a8f'],
          [/pagseg|pagbank/, '290', 'PagBank', '#1bb99a', '#1d8a74'],
          [/stone/, '197', 'Stone', '#00a868', '#1f8056'],
          [/safra/, '422', 'Safra', '#0b2341', '#34465e'],
          [/btg/, '208', 'BTG', '#0d1a4b', '#36416b']
        ];
        return (numero && marcas.find(m => m[1] === cod)) || marcas.find(m => m[0].test(n)) || null;
      },
      nomeCurtoBanco(nome) {
        const marca = this.marcaBanco(nome);
        return marca ? marca[2] : (nome || '');
      },
      semExtensao(nome) {
        const n = String(nome || '');
        const ponto = n.lastIndexOf('.');
        return ponto > 0 ? n.substring(0, ponto) : n;
      },
      partesCaminho(rotulo) {
        const partes = String(rotulo || '').replace(/\\/g, '/').split('/').filter(x => x);
        return { pastas: partes.slice(0, -1), arquivo: partes.length ? partes[partes.length - 1] : '' };
      },
      corBanco(nome, numero) {
        const n = (nome || '').toLowerCase();
        const paleta = [['#1c84c6', '#1f6a9c'], ['#23c6c8', '#1b8a8c'], ['#7a5af8', '#5f46c2'], ['#f8ac59', '#b0702a'], ['#ed5565', '#b33b49'], ['#1ab394', '#1d8a74'], ['#5b6570', '#4a535c']];
        const rgba = (hex, a) => 'rgba(' + parseInt(hex.substr(1, 2), 16) + ',' + parseInt(hex.substr(3, 2), 16) + ',' + parseInt(hex.substr(5, 2), 16) + ',' + a + ')';
        const marca = this.marcaBanco(nome, numero);
        let cor, texto;
        if (marca) { cor = marca[3]; texto = marca[4]; } else {
          let soma = 0;
          for (let i = 0; i < n.length; i++) soma += n.charCodeAt(i);
          cor = paleta[soma % paleta.length][0]; texto = paleta[soma % paleta.length][1];
        }
        return { background: rgba(cor, 0.12), color: texto, borderColor: rgba(cor, 0.35) };
      },
      tipoArquivoExtrato(nome) {
        const n = (nome || '').toLowerCase();
        if (n.endsWith('.xlsx')) return TIPOS_ARQUIVO_EXTRATO[1];
        if (n.endsWith('.ofx')) return TIPOS_ARQUIVO_EXTRATO[2];
        return TIPOS_ARQUIVO_EXTRATO[0];
      },
      separarPorTipo(itens) {
        return TIPOS_ARQUIVO_EXTRATO
          .map(t => Object.assign({}, t, { arquivos: itens.filter(i => i.tipo.chave === t.chave) }))
          .filter(t => t.arquivos.length > 0);
      },
      grupoContasMarcado(g) { return g.arquivos.every(i => this.arquivosContasMarcados[i.arquivo.nome]); },
      qtdGrupoContasMarc(g) { return g.arquivos.filter(i => this.arquivosContasMarcados[i.arquivo.nome]).length; },
      marcarGrupoContas(g, val) {
        const m = Object.assign({}, this.arquivosContasMarcados);
        g.arquivos.forEach(i => { m[i.arquivo.nome] = val; });
        this.arquivosContasMarcados = m;
      },
      enviarExtratoContas() {
        if (!this.isaacConfigurado) { toastr.warning(this.motivoIsaac || 'Integração com o Isaac Hub não configurada.'); return; }
        const selecionados = this.contasUploads.filter(a => this.arquivosContasMarcados[a.nome]).map(a => a.nome);
        if (selecionados.length === 0) { toastr.warning('Selecione ao menos um arquivo.'); return; }
        this.enviandoContas = true;
        conciliacaoProjetoServico.enviarExtratoContas(selecionados)
          .then(dados => {
            this.enviandoContas = false; this.mostrarEnvioContas = false;
            this.carregarPendentesEnvio();
            if (dados.jobId) { this.jobEnvio = dados.jobId; this.mostrarAcompanhamento = true; }
            else toastr.success('Enviado(s) ' + dados.enviados + ' arquivo(s) de extrato ao Isaac Hub.');
          })
          .catch(res => { this.enviandoContas = false; toastr.error(res && res.body && res.body.message ? res.body.message : 'Não foi possível enviar o extrato de contas.'); });
      },
      verificarEnvioAtivo() {
        conciliacaoProjetoServico.envioExtratoAtivo()
          .then(dados => { if (dados && dados.jobId && !this.jobEnvio) this.jobEnvio = dados.jobId; })
          .catch(() => {});
      },
      aoConcluirEnvio(dados) {
        this.carregarPendentesEnvio();
        this.lista(this.pagina);
        if (this.mostrarAcompanhamento) return;
        this.jobEnvio = '';
        this.progressoEnvio = null;
        const erro = dados && dados.situacao === 'ERRO';
        this.piscarEnvio(erro ? 'erro' : 'ok', (dados && dados.resumo) || '');
        if (erro) toastr.error('O processamento do extrato enviado foi interrompido: ' + (dados.resumo || 'veja o Isaac Hub.'));
        else toastr.success('O Isaac Hub terminou de processar o extrato enviado' + (dados && dados.resumo ? ': ' + dados.resumo : '.'));
      },
      fecharAcompanhamento(terminado) {
        this.mostrarAcompanhamento = false;
        if (terminado) { this.jobEnvio = ''; this.progressoEnvio = null; return; }
        this.destacarEnvio = false;
        this.$nextTick(() => {
          this.destacarEnvio = true;
          setTimeout(() => { this.destacarEnvio = false; }, 2600);
        });
      },
      enviarMaisArquivos() {
        this.fecharAcompanhamento(true);
        this.envioFlash = '';
        this.abrirEnvioContas();
      },
      piscarEnvio(tipo, resumo) {
        clearTimeout(this.timerFlash);
        this.envioFlash = tipo;
        this.envioFlashResumo = resumo;
        this.timerFlash = setTimeout(() => { this.envioFlash = ''; this.envioFlashResumo = ''; }, 10000);
      },
      clicarEnviar() {
        if (this.jobEnvio) { this.mostrarAcompanhamento = true; return; }
        this.envioFlash = '';
        this.abrirEnvioContas();
      },
      corProgresso(p) { return p >= 100 ? '#1ab394' : (p >= 50 ? '#f8ac59' : '#ed5565'); },
      situacao(r) {
        if (r.conciliado) return { label: 'Conciliado', cls: 'badge-ok', icon: 'fa-check' };
        if ((r.extratosPendentes || 0) > 0) return { label: 'Extrato pendente', cls: 'badge-no', icon: 'fa-university' };
        return { label: 'Em conciliação', cls: 'badge-andamento', icon: 'fa-refresh' };
      },
      pendencias(r) { return Math.max(0, (r.totalLancamentos || 0) - (r.lancamentosConciliados || 0)); },
      iniciou(r) { return (r.lancamentosConciliados || 0) > 0 || this.pendencias(r) > 0; },
      numero(v) { return (v || 0).toLocaleString('pt-BR'); },
      moeda(v) {
        const n = v || 0;
        const texto = Math.abs(n).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return (n < -0.004 ? '−R$ ' : 'R$ ') + texto;
      },
      moedaSinal(v) {
        const n = v || 0;
        return (n > 0.004 ? '+' : '') + this.moeda(n);
      },
      temBanco(t) { return !!t && t.saldoBanco !== null && t.saldoBanco !== undefined && t.dataSaldoBanco > 0; },
      textoPendencias(t) {
        const partes = [];
        if (t.lancamentosPorConciliar) partes.push(t.lancamentosPorConciliar + (t.lancamentosPorConciliar === 1 ? ' lançamento não conferido' : ' lançamentos não conferidos'));
        if (t.extratosPorConciliar) partes.push(t.extratosPorConciliar + (t.extratosPorConciliar === 1 ? ' linha de extrato' : ' linhas de extrato') + ' por conciliar');
        if (!partes.length && t.extratosPendentes) partes.push(t.extratosPendentes + ' linha(s) de extrato com lançamento ainda não conferido');
        return partes.join(' e ');
      },
      tituloSaldoTesouraria() {
        return 'Saldo dos lançamentos conferidos (conciliados) no Manager até o fim de ' + (this.dataReferenciaTesouraria || 'D-1') + ', pela data do lançamento; antes da data de corte da conciliação entram todos (mesmo cálculo da Posição de Tesouraria)';
      },
      tituloOperacao(t) {
        const partes = ['Saldo por operação (todos os lançamentos, conferidos ou não): ' + this.moeda(t.saldoOperacao)];
        partes.push('Conciliado: ' + this.moeda(t.saldoConciliado));
        partes.push('Diferença: ' + this.moedaSinal(t.diferencaOperacao));
        if (t.lancamentosNaoConferidos) partes.push(t.lancamentosNaoConferidos + (t.lancamentosNaoConferidos === 1 ? ' lançamento não conferido' : ' lançamentos não conferidos') + ' desde a data de corte');
        return partes.join('\n');
      },
      tituloDivergencia(t) {
        if (t.conciliacaoPendente) return 'Conciliação pendente: ' + this.textoPendencias(t);
        const textos = {
          'baixa pendente': 'Conta conciliada, mas há borderô com arquivo enviado e títulos sem baixa',
          'estrutural': 'Conta conciliada e ainda assim diferente do banco: diferença a investigar',
        };
        return textos[t.tipoDivergencia] || '';
      },
      iconeDivergencia(t) {
        if (t.conciliacaoPendente) return 'fa-hourglass-half';
        return t.tipoDivergencia === 'baixa pendente' ? 'fa-clock-o' : 'fa-exclamation-triangle';
      },
      corDivergencia(t) {
        if (t.conciliacaoPendente) return 'div-laranja';
        return t.tipoDivergencia === 'baixa pendente' ? 'div-roxo' : 'div-vermelho';
      },
      relativo(d) {
        if (!d) return '';
        const dt = moment(d, 'DD/MM/YYYY');
        if (!dt.isValid()) return '';
        const dias = moment().startOf('day').diff(dt.clone().startOf('day'), 'days');
        if (dias < 0) return '';
        if (dias === 0) return 'Hoje';
        if (dias === 1) return 'Ontem';
        if (dias < 30) return 'há ' + dias + ' dias';
        return '';
      },
    },
    created() {
      this.salvarFiltros();
      this.lista(this.pagina);
      if (permissoesConciliacao.alterar('banco')) { this.carregarPendentesEnvio(); this.verificarEnvioAtivo(); }
    },
    watch: {
      'filtros.status'() { this.agendarLista(); },
      'filtros.situacaoConta'() { this.agendarLista(); },
      'filtros.idConta'() { this.agendarLista(); this.$nextTick(() => this.sincronizarSelectConta()); },
      'filtros.banco'() {
        if (this.filtros.idConta) { this.$set(this.filtros, 'idConta', ''); this.$set(this.filtros, 'nomeConta', ''); }
        this.agendarLista();
        this.$nextTick(() => this.sincronizarSelectConta());
      },
      listaContas() { this.$nextTick(() => this.sincronizarSelectConta()); },
      'filtros.comExtrato'() { this.agendarLista(); },
      'filtros.ordem'() { this.agendarLista(); },
      filtros: { deep: true, handler() { this.salvarFiltros(); } },
    },
  }
</script>

<template>
  <div>
  <div class="lst-page">
  <div :class="['lst-card', {'animated': animated}, $root.animacaoPadrao]">

    <div class="lst-topo">

    <div class="lst-head">
      <div class="lst-head-esq">
      <div>
        <div class="lst-tit">Conciliação de Banco</div>
        <div class="lst-res">
          {{ resumo.totalConciliacoes }} {{ resumo.totalConciliacoes === 1 ? 'conta' : 'contas' }} ·
          {{ resumo.conciliadas }} {{ resumo.conciliadas === 1 ? 'conciliada' : 'conciliadas' }}
          <span v-if="pendentes > 0">· <span class="pend">{{ pendentes }} {{ pendentes === 1 ? 'pendente' : 'pendentes' }}</span> </span>· {{ indice }}% concluído
        </div>
      </div>
        <span class="lst-sep"></span>
        <button type="button" class="btn btn-success lst-atualizar" :disabled="atualizando" @click="atualizar" title="Recalcula os cards, a diferença, a lista e os arquivos novos do envio, mantendo os filtros">
          <i class="fa fa-refresh" :class="{ 'fa-spin': atualizando }"></i> Atualizar
        </button>
        <span class="lst-atu-hora" v-if="ultimaAtualizacao">atualizado às {{ ultimaAtualizacao }}</span>
      </div>
      <label class="lst-chk" v-if="possuiRestricaoResponsavel">
        <input type="checkbox" :checked="todos" @change="alternarTodos"> Mostrar todas as contas
      </label>
    </div>

    <div class="kpi-faixa">
      <button type="button" class="kpi-card kpi-todas" :class="{ ativo: filtros.status === '0' }" @click="filtrarStatus('0')">
        <div class="kpi-lbl">Todas as contas</div>
        <div class="kpi-val"><span class="kpi-num">{{ resumo.totalConciliacoes }}</span> <span class="kpi-qlf">{{ descricaoSituacao }}</span></div>
      </button>
      <button type="button" class="kpi-card kpi-ok" :class="{ ativo: filtros.status === '1' }" @click="filtrarStatus('1')">
        <div class="kpi-lbl"><span class="kpi-dot"></span> Conciliadas</div>
        <div class="kpi-val"><span class="kpi-num">{{ resumo.conciliadas }}</span> <span class="kpi-qlf">{{ pctConciliadas }}% do total</span></div>
      </button>
      <button type="button" class="kpi-card kpi-operacao" :class="{ ativo: filtros.status === '5' }" @click="filtrarStatus('5')"
              title="Contas com lançamento feito e ainda não conciliado desde a data de corte: o saldo por operação não bate com o conciliado">
        <div class="kpi-lbl"><span class="kpi-dot"></span> Em conciliação</div>
        <div class="kpi-val">
          <span class="kpi-num" v-if="qtdeOperacao !== null">{{ qtdeOperacao }}</span>
          <span class="kpi-num" v-else><i class="fa fa-spinner fa-pulse" style="font-size:15px"></i></span>
          <span class="kpi-qlf">operação × conciliado<template v-if="qtdeOperacao"> · {{ pctOperacao }}% do total</template></span>
        </div>
      </button>
      <button type="button" class="kpi-card kpi-andamento" :class="{ ativo: filtros.status === '4' }" @click="filtrarStatus('4')"
              title="Contas em que o saldo do extrato do banco não bate com o saldo conciliado no Manager na data do extrato">
        <div class="kpi-lbl"><span class="kpi-dot"></span> Com diferença</div>
        <div class="kpi-val">
          <span class="kpi-num" v-if="qtdeDiferenca !== null">{{ qtdeDiferenca }}</span>
          <span class="kpi-num" v-else><i class="fa fa-spinner fa-pulse" style="font-size:15px"></i></span>
          <span class="kpi-qlf">conciliado × banco<template v-if="qtdeDiferenca"> · {{ pctDiferenca }}% do total</template></span>
        </div>
      </button>
      <button type="button" class="kpi-card kpi-nunca" :class="{ ativo: filtros.status === '2' }" @click="filtrarStatus('2')"
              title="Contas com linhas do extrato do banco ainda por conciliar">
        <div class="kpi-lbl"><span class="kpi-dot"></span> Extrato pendente</div>
        <div class="kpi-val"><span class="kpi-num">{{ resumo.naoConciliadas }}</span> <span class="kpi-qlf">{{ pctNaoConciliadas }}% do total</span></div>
      </button>
    </div>

    <div class="ibox">
      <div class="ibox-title flt-titulo"><h5><i class="fa fa-filter"></i> Filtros</h5>
        <div class="rec-faixa">
          <span class="rec-total" v-if="carregando">Exibindo <b>…</b></span>
          <span class="rec-total" v-else>Exibindo <b>{{ totalRegistros || 0 }}</b> {{ totalRegistros === 1 ? 'conta' : 'contas' }}</span>
          <div class="rec-chips">
            <button v-for="c in chipsRecorte" :key="c.chave" type="button" class="rec-chip" :class="c.classe" :style="c.estilo" @click="c.remover" title="Clique para tirar este filtro">
              <i v-if="c.chave === 'banco'" class="fa fa-university"></i><i v-else-if="c.icone" class="fa" :class="c.icone"></i><span v-else-if="c.classe" class="rec-dot"></span>
              <span class="rec-rot">{{ c.rotulo }}</span>
              <i class="fa fa-times rec-x"></i>
            </button>
            <button v-if="temFiltro" type="button" class="rec-chip rec-chip-limpar" @click="limparFiltros">
              <i class="fa fa-eraser"></i> Limpar filtros
            </button>
          </div>
        </div>
        <div class="ibox-tools">
          <label class="flt-toggle" :class="{ 'flt-toggle-on': filtros.comExtrato }" title="Só contas que já receberam extrato desde a data de corte. As sem pendência ficam em Conciliadas e as com extrato pendente em Em conciliação. Contas transitórias não têm extrato e ficam de fora."><input type="checkbox" v-model="filtros.comExtrato"> Com extrato bancário</label>
        </div>
      </div>
      <div class="ibox-content">
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <label class="control-label">Conta</label>
              <select id="contaFiltro" class="form-control" v-model="filtros.idConta" style="width:100%">
                <option value=""></option>
                <option :value="c.idContaCript" v-for="c in contasDoBanco" :key="c.idContaCript">{{ c.nomeConta }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-2 col-sm-6">
            <div class="form-group">
              <label class="control-label">Banco</label>
              <select class="form-control" v-model="filtros.banco">
                <option value="">Todos os bancos</option>
                <option v-for="b in bancosOpcoes" :key="b" :value="b">{{ b }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-3 col-sm-6">
            <div class="form-group">
              <label class="control-label">Situação da conta</label>
              <div class="seg-situacao">
                <button type="button" :class="{ ativo: filtros.situacaoConta === '0' }" @click="filtros.situacaoConta = '0'">Ativas</button>
                <button type="button" :class="{ ativo: filtros.situacaoConta === '1' }" @click="filtros.situacaoConta = '1'">Encerradas</button>
                <button type="button" :class="{ ativo: filtros.situacaoConta === '2' }" @click="filtros.situacaoConta = '2'">Todas</button>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6">
            <div class="form-group">
              <label class="control-label">Ordenar por</label>
              <select class="form-control" v-model="filtros.ordem">
                <option value="">Padrão (pendentes primeiro)</option>
                <option value="extrato">Extrato mais antigo</option>
                <option value="extrato-menos">Reta final — extrato quase limpo</option>
                <option value="extrato-mais">Mutirão — extrato mais atolado</option>
                <option value="pendencias">Mais itens pendentes</option>
                <option value="percentual">Menor % conciliado</option>
                <option value="conta">Conta (A–Z)</option>
                <option value="diferenca-maior">Maior diferença</option>
                <option value="diferenca-menor">Menor diferença</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    </div>

    <div class="ibox tabela-ibox lst-corpo" ref="corpo">
      <div class="ibox-content">
        <div class="table-responsive">
          <table class="table table-hover tabela-conc">
            <thead>
              <tr>
                <th>Conta</th>
                <th>Banco</th>
                <th class="text-right sep" :title="tituloSaldoTesouraria()">Saldo em {{ dataReferenciaTesouraria || 'D-1' }}</th>
                <th class="text-right" title="Último saldo lido no extrato do banco até a data de referência">Extrato em {{ dataReferenciaTesouraria || 'D-1' }}</th>
                <th class="text-right sep-r" title="Saldo do banco menos o conciliado no Manager na data do saldo do banco">Diferença</th>
                <th>Status</th>
                <th class="text-right">Pendências</th>
                <th style="min-width:170px">Conclusão</th>
                <th>Última atualização</th>
                <th class="text-right">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in registros" :key="r.idContaCript">
                <td class="col-projeto">{{ r.nomeConta }} <span v-if="r.encerrada" class="tag-encerrada">encerrada</span><span v-if="r.transitoria" class="tag-transitoria" title="Conta transitória: a conciliação casa contas a receber com os débitos da conta, sem extrato bancário">transitória</span></td>
                <td class="col-banco">
                  <template v-if="r.numeroBanco || r.nomeBanco">
                    <b class="mono">{{ r.numeroBanco }}</b><span v-if="r.nomeBanco" class="text-muted"> · {{ r.nomeBanco }}</span>
                  </template>
                  <span v-else class="text-muted">—</span>
                </td>
                <td class="text-right num sep" :title="r.tesouraria ? tituloSaldoTesouraria() : ''">
                  <template v-if="r.tesouraria">
                    <span :class="{ neg: r.tesouraria.saldoConciliado < 0 }">{{ moeda(r.tesouraria.saldoConciliado) }}</span>
                    <span class="sub">conciliado no Manager</span>
                    <span v-if="r.tesouraria.divergenciaOperacao" class="sub sub-op" :title="tituloOperacao(r.tesouraria)">
                      <i class="fa fa-exclamation-circle"></i> operação {{ moeda(r.tesouraria.saldoOperacao) }}
                    </span>
                  </template>
                  <span v-else class="mudo" :title="r.transitoria ? 'Conta transitória não entra na Posição de Tesouraria' : 'Conta fora da Posição de Tesouraria'">—</span>
                </td>
                <td class="text-right num">
                  <template v-if="temBanco(r.tesouraria)">
                    <span :class="{ neg: r.tesouraria.saldoBanco < 0 }">{{ moeda(r.tesouraria.saldoBanco) }}</span>
                    <span class="sub">lido em {{ r.tesouraria.dataSaldoBancoTexto }}</span>
                  </template>
                  <template v-else-if="r.tesouraria">
                    <span class="mudo">—</span>
                    <span class="sub">sem saldo no extrato</span>
                  </template>
                  <span v-else class="mudo">—</span>
                </td>
                <td class="text-right num sep-r">
                  <span v-if="!temBanco(r.tesouraria)" class="mudo">—</span>
                  <span v-else-if="!r.tesouraria.divergente && !r.tesouraria.conciliacaoPendente" class="ok">R$ 0,00</span>
                  <span v-else class="div-cel" :title="tituloDivergencia(r.tesouraria)">
                    <span :class="r.tesouraria.conciliacaoPendente ? 'pend-val' : 'neg'">{{ moedaSinal(r.tesouraria.divergencia) }}</span>
                    <i class="fa" :class="[iconeDivergencia(r.tesouraria), corDivergencia(r.tesouraria)]"></i>
                  </span>
                </td>
                <td>
                  <span class="badge-status" :class="situacao(r).cls"><i class="fa" :class="situacao(r).icon"></i> {{ situacao(r).label }}</span>
                </td>
                <td class="text-right">
                  <template v-if="iniciou(r)">
                    <div class="pendencias" :class="{ 'pend-zero': pendencias(r) === 0 }">{{ numero(pendencias(r)) }}</div>
                    <small class="text-muted">itens</small>
                  </template>
                  <span v-else class="text-muted">—</span>
                </td>
                <td>
                  <template v-if="iniciou(r)">
                    <div class="barra-conc">
                      <span :style="{ width: r.percentualConclusao + '%', background: corProgresso(r.percentualConclusao) }"></span>
                    </div>
                    <div class="barra-legenda">
                      <span class="dot" :style="{ background: corProgresso(r.percentualConclusao) }"></span>
                      <strong :style="{ color: corProgresso(r.percentualConclusao) }">{{ r.percentualConclusao }}%</strong>
                      <span class="text-muted">· {{ numero(r.lancamentosConciliados) }} / {{ numero(r.totalLancamentos) }} itens</span>
                    </div>
                  </template>
                  <span v-else class="text-muted"><em>Não iniciada</em></span>
                </td>
                <td class="nowrap">
                  <div>{{ r.ultimaAtualizacao || '---' }}<span class="text-muted" v-if="relativo(r.ultimaAtualizacao)"> · {{ relativo(r.ultimaAtualizacao) }}</span></div>
                  <small class="text-muted col-usuario" v-if="r.usuarioUltimaAtualizacao" :title="'Última alteração feita por ' + r.usuarioUltimaAtualizacao">
                    <i class="fa fa-user-o"></i> {{ r.usuarioUltimaAtualizacao }}
                  </small>
                </td>
                <td class="text-right nowrap">
                  <button type="button" class="btn btn-primary btn-abrir" @click="abrirConciliacao(r)">
                    Abrir conciliação <i class="fa fa-arrow-right"></i>
                  </button>
                  <button v-if="!r.transitoria && r.tesouraria && podeTesouraria" type="button" class="btn-aplic" title="Ver o detalhe da conta (Posição de Tesouraria)" @click="contaDetalhe = r.idContaCript"><i class="fa fa-eye"></i></button>
                  <span v-else class="btn-aplic btn-aplic-vazio"></span>
                  <button v-if="!r.transitoria" type="button" class="btn-aplic" title="Aplicações da conta" @click="aplicacoesConta = r"><i class="fa fa-line-chart"></i></button>
                  <span v-else class="btn-aplic btn-aplic-vazio"></span>
                </td>
              </tr>
              <tr v-show="carregando"><td colspan="10" class="text-center text-muted" style="padding:24px"><i class="fa fa-spinner fa-pulse fa-2x"></i><div class="m-t-xs">Carregando...</div></td></tr>
              <tr v-show="!carregando && registros.length === 0"><td colspan="10" class="text-center text-muted" style="padding:24px">Nenhuma conta encontrada.</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="acoes-rodape">
      <div class="acoes-rodape-l">
        <button v-if="podeConfigurar" type="button" class="btn btn-white" @click="abrirConfiguracao"><i class="fa fa-cog"></i> Configurações</button>
        <button v-if="podeTesouraria" type="button" class="btn btn-white" @click="abrirTesouraria" title="Abre a Posição de Tesouraria"><i class="fa fa-bar-chart"></i> Posição de Tesouraria</button>
      </div>
      <div class="acoes-rodape-c">
        <div class="pag" v-if="totalRegistros > 0">
          <button v-if="totalPaginas > 1" type="button" :disabled="pagina <= 1" aria-label="Anterior" @click="irPagina(pagina - 1)"><i class="fa fa-angle-left"></i></button>
          <button v-for="p in paginas" :key="'p' + p" type="button" :class="{ ativo: p === pagina }" @click="irPagina(p)">{{ p }}</button>
          <button v-if="totalPaginas > 1" type="button" :disabled="pagina >= totalPaginas" aria-label="Próxima" @click="irPagina(pagina + 1)"><i class="fa fa-angle-right"></i></button>
        </div>
        <span class="pag-info">{{ infoPaginacao }}</span>
      </div>
      <div class="acoes-rodape-r">
        <button v-if="!podeAlterar" type="button" class="btn-passo passo-2" @click="abrirIgnoradas"
                title="Quais contas receberam crédito, de quem e por qual extrato">
          <span class="passo-n"><i class="fa fa-eye"></i></span>
          <span class="passo-txt">
            <b><i class="fa fa-check-circle-o"></i> Créditos identificados</b>
            <small>só consulta</small>
          </span>
        </button>
        <template v-if="podeAlterar">
        <span class="acoes-sep"></span>
        <button type="button" class="btn-passo passo-1"
                :class="{ 'passo-andamento': !!jobEnvio, 'passo-destaque': destacarEnvio, 'passo-feito': !jobEnvio && envioFlash === 'ok', 'passo-falhou': !jobEnvio && envioFlash === 'erro' }"
                :style="jobEnvio ? estiloBotaoEnvio : null"
                :disabled="!isaacConfigurado && !jobEnvio" @click="clicarEnviar"
                :title="jobEnvio ? 'O Isaac Hub está processando o extrato enviado. Clique para acompanhar.' : (isaacConfigurado ? 'Envia ao Isaac Hub os extratos multi-conta que estão na pasta compartilhada' : motivoIsaac)">
          <span class="passo-n">
            <i v-if="jobEnvio" class="fa fa-cog fa-spin"></i>
            <i v-else-if="envioFlash === 'ok'" class="fa fa-check"></i>
            <i v-else-if="envioFlash === 'erro'" class="fa fa-exclamation"></i>
            <template v-else>1</template>
          </span>
          <span class="passo-txt">
            <template v-if="jobEnvio">
              <b><i class="fa fa-cloud-upload"></i> Processando extrato <span class="passo-pct">{{ progressoEnvio ? progressoEnvio.percentual : 0 }}%</span></b>
              <small>{{ (progressoEnvio && progressoEnvio.detalhe) || 'iniciando' }} · <u>ver andamento</u></small>
            </template>
            <template v-else-if="envioFlash">
              <b><i class="fa" :class="envioFlash === 'ok' ? 'fa-check-circle' : 'fa-exclamation-triangle'"></i> {{ envioFlash === 'ok' ? 'Extrato processado' : 'Processamento interrompido' }}</b>
              <small>{{ envioFlashResumo || 'clique para enviar outro' }}</small>
            </template>
            <template v-else>
              <b><i class="fa fa-cloud-upload"></i> Enviar extrato</b>
              <small>{{ textoEnvioPendentes }}</small>
            </template>
          </span>
        </button>
        <i class="fa fa-angle-right passo-seta"></i>
        <div class="passo-drop">
          <div v-if="menuPasso2" class="passo-menu-fundo" @click="menuPasso2 = false"></div>
          <button type="button" class="btn-passo passo-2" :class="{ aberto: menuPasso2 }" @click="menuPasso2 = !menuPasso2"
                  title="Confere os créditos recebidos e lança as tarifas de pagamento antes de processar">
            <span class="passo-n">2</span>
            <span class="passo-txt">
              <b><i class="fa fa-check-square-o"></i> Conferir e lançar <i class="fa passo-caret" :class="menuPasso2 ? 'fa-caret-down' : 'fa-caret-up'"></i></b>
              <small>créditos e tarifas</small>
            </span>
          </button>
          <div v-if="menuPasso2" class="passo-menu">
            <a href="#" @click.prevent="abrirIgnoradas"><i class="fa fa-check-circle-o"></i> <b>Créditos identificados</b><small>quais contas receberam crédito, de quem e por qual extrato</small></a>
            <a href="#" @click.prevent="abrirTarifas"><i class="fa fa-money"></i> <b>Lançar tarifas de pagamento</b><small>tarifas TED/DOC por borderô, conferidas com o extrato</small></a>
            <a href="#" @click.prevent="abrirRateioPlanilha"><i class="fa fa-sitemap"></i> <b>Rateio por planilha</b><small>troca os rateios do lançamento pelos da planilha (câmbio, contas a pagar)</small></a>
          </div>
        </div>
        <i class="fa fa-angle-right passo-seta"></i>
        <button type="button" class="btn-passo passo-3" :disabled="processando" @click="abrirProcessamento"
                title="Roda a conciliação automática de banco em todas as contas com extrato pendente e, se configurado, lança aplicação e resgate">
          <span class="passo-n"><i v-if="processando" class="fa fa-spinner fa-pulse"></i><template v-else>3</template></span>
          <span class="passo-txt">
            <b><i class="fa fa-magic"></i> Processar todas as contas</b>
            <small>{{ processando ? 'processando...' : 'conciliação automática' }}</small>
          </span>
        </button>
        </template>
        <span class="acoes-sep"></span>
        <button type="button" class="btn btn-primary" :disabled="exportando || carregando || !totalRegistros" @click="exportar" title="Exporta todas as contas da lista, com os filtros atuais, para Excel">
          <i class="fa" :class="exportando ? 'fa-spinner fa-pulse' : 'fa-file-excel-o'"></i> {{ exportando ? 'Exportando...' : 'Exportar Excel' }}
        </button>
      </div>
    </div>

  </div>
  </div>

    <configuracao-credito-modal v-if="mostrarConfiguracao" @fechar="fecharConfiguracao" @salvo="aoSalvarConfiguracao"></configuracao-credito-modal>

    <creditos-identificados-lista v-if="mostrarIgnoradas" @fechar="fecharIgnoradas"></creditos-identificados-lista>

    <tarifas-bordero-modal v-if="mostrarTarifas" @fechar="mostrarTarifas = false" @gerado="aoGerarTarifas"></tarifas-bordero-modal>
    <rateio-planilha-modal v-if="mostrarRateioPlanilha" @fechar="mostrarRateioPlanilha = false" @aplicado="aoGerarTarifas"></rateio-planilha-modal>

    <div v-if="mostrarProcessamento" class="conc-ov">
      <div class="conc-modal proc-modal">
        <div class="proc-head">
          <h4>Processar todas as contas</h4>
          <small class="proc-sub">Roda em cada conta com extrato pendente a mesma conciliação automática que acontece ao abrir a conta.</small>
        </div>

        <div class="proc-corpo">
          <div v-if="carregandoPrevia" class="proc-carregando"><i class="fa fa-spinner fa-pulse fa-2x"></i></div>
          <template v-else>
            <div class="proc-cards">
              <div class="proc-card">
                <div class="proc-lbl">Contas a processar</div>
                <div class="proc-num">{{ numero(previa.contas) }}</div>
                <div class="proc-obs">{{ numero(previa.extratosPendentes - previa.extratosAConferir) }} linha(s) de extrato sem par</div>
                <div class="proc-obs" v-if="previa.extratosAConferir > 0"
                     title="Linhas que o Isaac já casou na importação, com o lançamento ainda não conferido. O processamento confere esses lançamentos.">
                  + {{ numero(previa.extratosAConferir) }} já casada(s) pelo Isaac, falta conferir o lançamento<template v-if="previa.contasSoAConferir > 0"> ({{ numero(previa.contasSoAConferir) }} conta(s) só com esse caso, fora do card "Extrato pendente")</template>
                </div>
              </div>
              <div class="proc-card">
                <div class="proc-lbl">Período considerado</div>
                <div class="proc-txt">do extrato pendente mais antigo de cada conta</div>
                <div class="proc-obs">{{ previa.dataCorte ? 'nunca antes de ' + dataCorteTexto() : 'sem data de corte configurada' }}</div>
              </div>
            </div>

            <div class="proc-auto" :class="previa.automacaoAplicacaoResgate ? 'auto-on' : 'auto-off'">
              <template v-if="previa.automacaoAplicacaoResgate">
                <b><i class="fa fa-bolt"></i> Aplicação e resgate automáticos ligados</b>
                <span>{{ numero(previa.contasAplicacaoUnica) }} das {{ numero(previa.contas) }} contas têm uma única aplicação ativa —
                  só nelas as linhas reconhecidas como aplicação ou resgate são lançadas. As demais continuam manuais.</span>
              </template>
              <template v-else>
                <b><i class="fa fa-info-circle"></i> Só conciliação automática</b>
                <span>Aplicação e resgate não serão lançados. Para ligar, marque a opção em Configurações → Transferências e aplicações.</span>
              </template>
            </div>

            <div v-if="previa.contas === 0" class="proc-alerta">
              Nenhuma conta ativa com extrato pendente. Envie o extrato antes de processar.
            </div>

            <div v-if="sugestoesAplicacao.length && !processando" class="proc-sug">
              <div class="proc-sug-tit"><i class="fa fa-lightbulb-o"></i> Parecem aplicação ou resgate</div>
              <div class="proc-sug-txt">
                Estas linhas do extrato têm cara de aplicação ou resgate, mas o texto não está cadastrado.
                Confirmando, o texto entra em Configurações → Transferências e aplicações<template v-if="previa.automacaoAplicacaoResgate"> e o Processar já lança</template>.
                Rejeitando, a sugestão não aparece mais.
              </div>
              <div v-for="s in sugestoesAplicacao" :key="s.original" class="proc-sug-item">
                <div class="proc-sug-campo">
                  <input type="text" class="form-control input-sm" maxlength="200" v-model="s.texto" :disabled="!podeConfigurar" :title="'Exemplo no extrato: ' + s.exemplo">
                  <small>{{ resumoSugestao(s) }} · ex.: {{ s.exemplo }}</small>
                </div>
                <template v-if="podeConfigurar">
                  <button type="button" class="btn btn-linha btn-primary" :disabled="!!gravandoSugestao" @click="decidirSugestao(s, true)" title="Cadastrar este texto em aplicação e resgate">
                    <i class="fa" :class="gravandoSugestao === s.original ? 'fa-spinner fa-pulse' : 'fa-check'"></i> Confirmar
                  </button>
                  <button type="button" class="btn btn-linha btn-white" :disabled="!!gravandoSugestao" @click="decidirSugestao(s, false)" title="Não é aplicação nem resgate — não sugerir mais">
                    <i class="fa fa-times"></i> Rejeitar
                  </button>
                </template>
              </div>
              <div v-if="!podeConfigurar" class="proc-sug-txt">Só quem configura a conciliação de banco pode confirmar ou rejeitar.</div>
            </div>

            <div v-if="processando" class="proc-progresso">
              <i class="fa fa-spinner fa-pulse"></i>
              {{ numero(contasProcessadas) }} de {{ numero(previa.contas) }} conta(s) ·
              {{ numero(conciliadosProcesso) }} conciliados ·
              {{ numero(aplicacoesProcesso) }} aplicações · {{ numero(resgatesProcesso) }} resgates
            </div>

            <div v-else-if="contasProcessadas > 0" class="proc-progresso proc-fim">
              <i class="fa fa-check-circle"></i>
              {{ numero(contasProcessadas) }} conta(s) processadas ·
              {{ numero(conciliadosProcesso) }} conciliados ·
              {{ numero(aplicacoesProcesso) }} aplicações · {{ numero(resgatesProcesso) }} resgates
              <span v-if="falhasProcesso > 0"> · {{ numero(falhasProcesso) }} não lançados</span>
            </div>

            <div v-if="paresDesfeitosProcesso.length > 0" class="proc-avisos proc-desfeitos">
              <div class="proc-avisos-tit">Conciliações desfeitas porque foram alteradas fora do módulo</div>
              <ul>
                <li v-for="(a, i) in paresDesfeitosProcesso" :key="i">{{ a }}</li>
              </ul>
            </div>

            <div v-if="avisosProcesso.length > 0" class="proc-avisos">
              <div class="proc-avisos-tit">Contas que ficaram para lançamento manual</div>
              <ul>
                <li v-for="(a, i) in avisosProcesso" :key="i">{{ a }}</li>
              </ul>
            </div>
          </template>
        </div>

        <div class="proc-foot">
          <button type="button" class="btn btn-primary" :disabled="processando || carregandoPrevia || previa.contas === 0" @click="processarContas">
            <i class="fa" :class="processando ? 'fa-spinner fa-pulse' : 'fa-magic'"></i>
            {{ processando ? 'Processando...' : 'Processar agora' }}
          </button>
          <button type="button" class="btn btn-sair" :disabled="processando" @click="fecharProcessamento"><i class="fa fa-sign-out"></i> Sair</button>
        </div>
      </div>
    </div>

    <div v-if="mostrarEnvioContas" class="conc-ov">
      <div class="conc-modal env-modal">
        <div class="env-head">
          <div><h4>Enviar extrato multi-conta</h4><small class="env-sub">O Web identifica as contas dentro do arquivo e envia ao Isaac Hub.</small></div>
        </div>
        <div class="env-corpo">
          <div v-if="carregandoContasLista" class="env-vazio"><i class="fa fa-spinner fa-pulse fa-2x"></i></div>
          <template v-else>
            <div v-if="!isaacConfigurado" class="env-bloqueio">
              <i class="fa fa-plug"></i>
              <span>{{ motivoIsaac }}</span>
            </div>
            <div v-if="contasUploads.length === 0" class="env-vazio">
              <i class="fa fa-file-pdf-o env-vazio-ic"></i>
              <p class="env-vazio-t">Nenhum extrato encontrado</p>
              <p class="env-vazio-s">Coloque o extrato (PDF, Excel ou OFX) na pasta compartilhada e clique em Atualizar.</p>
            </div>
            <template v-else>
              <div class="env-topo">
                <label class="env-check"><input type="checkbox" :checked="todosContasMarc" @change="marcarTodosContas($event.target.checked)"> Selecionar todos</label>
                <span class="env-cont">{{ contasUploads.length }} arquivo(s)</span>
              </div>
              <div class="env-lista">
                <div v-for="g in gruposContas" :key="g.chave" class="env-grupo">
                  <label v-if="g.chave" class="env-grupo-cab" :class="{ sel: grupoContasMarcado(g) }">
                    <input type="checkbox" :checked="grupoContasMarcado(g)" @change="marcarGrupoContas(g, $event.target.checked)">
                    <span class="env-grupo-badge" :style="corBanco(g.chave)"><i class="fa fa-university"></i> {{ g.chave }}</span>
                    <span class="env-grupo-qtd">{{ qtdGrupoContasMarc(g) > 0 ? qtdGrupoContasMarc(g) + ' de ' : '' }}{{ g.arquivos.length }} arquivo{{ g.arquivos.length > 1 ? 's' : '' }}</span>
                  </label>
                  <template v-for="t in g.tipos">
                    <label v-if="g.tipos.length > 1" :key="g.chave + '|' + t.chave" class="env-subgrupo-cab" :class="{ sel: grupoContasMarcado(t), 'env-item-grupo': g.chave }">
                      <input type="checkbox" :checked="grupoContasMarcado(t)" @change="marcarGrupoContas(t, $event.target.checked)">
                      <span class="env-tipo" :class="'env-tipo-' + t.chave">{{ t.rotulo }}</span>
                      <span class="env-grupo-qtd">{{ qtdGrupoContasMarc(t) > 0 ? qtdGrupoContasMarc(t) + ' de ' : '' }}{{ t.arquivos.length }} arquivo{{ t.arquivos.length > 1 ? 's' : '' }}</span>
                    </label>
                    <template v-for="(i, ia) in t.arquivos">
                      <div v-if="ia === 0 || partesCaminho(t.arquivos[ia - 1].rotulo).pastas.join('/') !== partesCaminho(i.rotulo).pastas.join('/')"
                           :key="'pasta|' + i.arquivo.nome" class="env-pasta-cab" :class="{ 'env-item-grupo': g.chave, 'env-item-subgrupo': g.tipos.length > 1 }">
                        <i class="fa fa-folder-open-o"></i>
                        <template v-if="partesCaminho(i.rotulo).pastas.length">
                          <template v-for="(pasta, ip) in partesCaminho(i.rotulo).pastas">
                            <i v-if="ip > 0" :key="'s' + ip" class="fa fa-angle-right env-sep"></i>
                            <span :key="'p' + ip" :class="{ 'env-pasta-dia': ip === partesCaminho(i.rotulo).pastas.length - 1 }">{{ pasta }}</span>
                          </template>
                        </template>
                        <span v-else>raiz da pasta</span>
                      </div>
                      <label :key="i.arquivo.nome" class="env-item" :class="{ sel: arquivosContasMarcados[i.arquivo.nome], falhou: i.arquivo.situacao, 'env-item-grupo': g.chave, 'env-item-subgrupo': g.tipos.length > 1 }">
                        <input type="checkbox" v-model="arquivosContasMarcados[i.arquivo.nome]">
                        <span class="env-tipo" :class="'env-tipo-' + i.tipo.chave">{{ i.tipo.rotulo }}</span>
                        <span class="env-nome">
                          <span class="env-arquivo">{{ semExtensao(partesCaminho(i.rotulo).arquivo) }}</span>
                          <small v-if="i.arquivo.situacao" class="env-aviso">
                            <i class="fa fa-exclamation-triangle"></i>
                            Enviado em {{ i.arquivo.dataEnvio }} e não virou lançamento{{ i.arquivo.detalhe ? ' — ' + i.arquivo.detalhe : '' }}
                          </small>
                        </span>
                      </label>
                    </template>
                  </template>
                </div>
              </div>
            </template>
          </template>
        </div>
        <div class="env-foot">
          <button type="button" class="btn btn-white" @click="abrirEnvioContas"><i class="fa fa-refresh"></i> Atualizar</button>
          <div class="env-foot-r">
            <button type="button" class="btn btn-primary" :disabled="enviandoContas || qtdContasMarc === 0 || !isaacConfigurado" @click="enviarExtratoContas"><i class="fa" :class="enviandoContas ? 'fa-spinner fa-pulse' : 'fa-cloud-upload'"></i> Enviar<span v-if="qtdContasMarc > 0"> {{ qtdContasMarc }} arquivo{{ qtdContasMarc > 1 ? 's' : '' }}</span></button>
            <button type="button" class="btn btn-sair" @click="fecharEnvioContas"><i class="fa fa-sign-out"></i> Sair</button>
          </div>
        </div>
      </div>
    </div>

    <acompanhamento-envio-modal v-if="jobEnvio" v-show="mostrarAcompanhamento" :key="jobEnvio" :job-id="jobEnvio" @fechar="fecharAcompanhamento" @enviar-mais="enviarMaisArquivos" @concluido="aoConcluirEnvio" @progresso="progressoEnvio = $event"></acompanhamento-envio-modal>

    <aplicacoes-conta-modal v-if="aplicacoesConta" :conta="aplicacoesConta" @fechar="aplicacoesConta = null"></aplicacoes-conta-modal>
    <posicao-tesouraria-detalhe v-if="contaDetalhe" :key="contaDetalhe" :id-conta-cript="contaDetalhe" :horizonte="0" :pode-tratar="podeTratarTesouraria"
      @fechar="contaDetalhe = ''"></posicao-tesouraria-detalhe>
  </div>
</template>

<style scoped>
  .kpi-faixa { display: grid; grid-template-columns: repeat(5, 1fr); gap: 10px; padding: 12px 16px; }
  .kpi-card {
    text-align: left; padding: 10px 13px; background: #fff; border: 1px solid #e6e9ed; border-radius: 7px;
    transition: border-color .12s, background .12s;
  }
  .kpi-card:hover { border-color: #c6ccd4; }
  .kpi-lbl { display: flex; align-items: center; gap: 6px; font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; }
  .kpi-dot { width: 7px; height: 7px; border-radius: 50%; background: currentColor; }
  .kpi-val { margin-top: 4px; }
  .kpi-num { font-family: 'IBM Plex Mono', Consolas, monospace; font-variant-numeric: tabular-nums; font-size: 21px; font-weight: 600; color: #1c2024; }
  .kpi-qlf { font-size: 11.5px; color: #8a939c; margin-left: 5px; }

  .kpi-ok .kpi-lbl, .kpi-ok .kpi-num { color: #0a6d4d; }
  .kpi-andamento .kpi-lbl, .kpi-andamento .kpi-num { color: #c98a00; }
  .kpi-operacao .kpi-lbl, .kpi-operacao .kpi-num { color: #2b5b8c; }
  .kpi-operacao.ativo { border-color: #5b8cc4; background: #f3f8fd; box-shadow: inset 0 0 0 1px #5b8cc4; }
  .kpi-nunca .kpi-lbl, .kpi-nunca .kpi-num { color: #a13c3c; }

  .kpi-card.ativo { border-color: #a9b2bb; background: #f7f9fa; box-shadow: inset 0 0 0 1px #a9b2bb; }
  .kpi-ok.ativo { border-color: #0f8a5f; background: #f4faf7; box-shadow: inset 0 0 0 1px #0f8a5f; }
  .kpi-andamento.ativo { border-color: #c98a00; background: #fdf9ef; box-shadow: inset 0 0 0 1px #c98a00; }
  .kpi-nunca.ativo { border-color: #c98080; background: #fdf7f7; box-shadow: inset 0 0 0 1px #c98080; }

  .lst-page { box-sizing: border-box; position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: #eceef1; padding: 12px 14px; overflow: auto; }
  .lst-card { min-width: 1080px; height: 100%; display: flex; flex-direction: column; background: #fff; border: 1px solid #d3d8de; border-radius: 8px; box-shadow: 0 1px 2px rgba(16,24,40,.06); overflow: hidden; }
  .lst-topo { flex: 0 0 auto; padding: 0 0 0; }
  .lst-head-esq { display: flex; align-items: center; gap: 12px; }
  .lst-sep { align-self: stretch; width: 1px; background: #dfe3e8; margin: 2px 4px; }
  .flt-titulo { display: flex; align-items: center; gap: 14px; min-height: 48px; }
  .flt-titulo h5 { float: none; margin: 0; white-space: nowrap; }
  .flt-titulo .ibox-tools { float: none; margin-left: auto; white-space: nowrap; }
  .lst-atualizar { height: 34px; padding: 0 14px; font-size: 13px; font-weight: 600; }
  .btn-linha { height: 30px; padding: 0 12px; font-size: 12.5px; font-weight: 600; }
  .lst-atu-hora { font-size: 11.5px; color: #8a939c; }
  .rec-faixa { display: flex; align-items: center; gap: 12px; flex: 1 1 auto; min-width: 0; padding-left: 14px; border-left: 1px solid #e6e9ed; }
  .rec-total { font-size: 12px; color: #6b747e; white-space: nowrap; }
  .rec-total b { font-family: 'IBM Plex Mono', Consolas, monospace; color: #1c2024; }
  .rec-chips { display: flex; flex-wrap: wrap; gap: 6px; flex: 1 1 auto; }
  .rec-chip { display: inline-flex; align-items: center; gap: 6px; height: 28px; padding: 0 10px; border: 1px solid #b7dcc9; border-radius: 14px; background: #e8f5ef; color: #0a6d4d; font-size: 12px; font-weight: 600; max-width: 360px; transition: background .12s, border-color .12s, color .12s; }
  .rec-rot { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .rec-x { font-size: 11px; opacity: .55; }
  .rec-dot { width: 7px; height: 7px; border-radius: 50%; background: currentColor; }
  .rec-ok { background: #f4faf7; border-color: #9fd3bd; color: #0a6d4d; }
  .rec-operacao { background: #f3f8fd; border-color: #a9c6e6; color: #2b5b8c; }
  .rec-andamento { background: #fdf9ef; border-color: #e6cd8f; color: #9a6a00; }
  .rec-nunca { background: #fdf7f7; border-color: #e3bcbc; color: #a13c3c; }
  .rec-chip:not(.rec-chip-limpar):hover { background: #fdf2f2 !important; border-color: #e3a5a5 !important; color: #a13c3c !important; }
  .rec-chip:not(.rec-chip-limpar):hover .rec-x { opacity: 1; }
  .rec-chip-limpar { border: 1px dashed #b9c3cd; background: #fff; color: #5b6570; }
  .rec-chip-limpar:hover { background: #f1f5f9; border-color: #8a939c; }
  .kpi-card.ativo { position: relative; }
  .kpi-card.ativo::after { content: ''; position: absolute; left: 50%; bottom: -7px; margin-left: -6px; border-left: 6px solid transparent; border-right: 6px solid transparent; border-top: 6px solid #a9b2bb; }
  .kpi-ok.ativo::after { border-top-color: #0f8a5f; }
  .kpi-operacao.ativo::after { border-top-color: #5b8cc4; }
  .kpi-andamento.ativo::after { border-top-color: #c98a00; }
  .kpi-nunca.ativo::after { border-top-color: #c98080; }
  .lst-head { display: flex; justify-content: space-between; align-items: flex-start; padding: 11px 16px 9px; border-bottom: 1px solid #eef1f4; }
  .lst-tit { font-size: 13.5px; font-weight: 600; color: #1c2024; }
  .lst-res { font-family: 'IBM Plex Mono', Consolas, monospace; font-size: 12px; color: #6b747e; margin-top: 2px; }
  .lst-res .pend { color: #c98a00; }
  .lst-chk { display: inline-flex; align-items: center; gap: 6px; font-size: 12px; font-weight: normal; color: #3b444d; margin: 0; cursor: pointer; padding: 5px 10px; border: 1px solid #dfe3e8; border-radius: 5px; }
  .lst-chk input { width: 13px; height: 13px; margin: 0; }
  .lst-corpo { flex: 1 1 auto; min-height: 0; overflow: auto; margin: 0; border: none; box-shadow: none; }
  .lst-topo .ibox { border: none; box-shadow: none; margin-bottom: 10px; }
  .lst-corpo .ibox-content { border: none; padding-top: 0; }

  .acoes-rodape {
    flex: 0 0 auto; display: grid; grid-template-columns: auto minmax(0, 1fr) auto; align-items: center; gap: 12px;
    padding: 12px 14px; background: #f7f9fa; border-top: 1px solid #dfe3e8;
  }
  .acoes-rodape-l { display: flex; align-items: center; gap: 8px; }
  .acoes-rodape-r { display: flex; align-items: center; justify-content: flex-end; gap: 6px; }
  .flt-toggle { display: inline-flex; align-items: center; gap: 6px; height: 26px; padding: 0 10px; margin: 0 6px 0 0; border: 1px solid #c6ccd4; border-radius: 5px; background: #fff; font-size: 12px; font-weight: 400; color: #3b444d; cursor: pointer; user-select: none; vertical-align: middle; }
  .flt-toggle input { margin: 0; }
  .flt-toggle-on { background: #e8f5ef; border-color: #0f8a5f; color: #0a6d4d; font-weight: 600; }
  .acoes-rodape-c { display: flex; flex-direction: column; align-items: center; gap: 4px; min-width: 0; }
  .pag { display: inline-flex; align-items: center; gap: 2px; }
  .pag button { min-width: 30px; height: 30px; padding: 0 9px; border: 1px solid #dfe3e8; background: #fff; color: #5b6570; font-size: 12.5px; cursor: pointer; }
  .pag button.ativo { background: #1ab394; border-color: #1ab394; color: #fff; font-weight: 600; }
  .pag button[disabled] { color: #c7cdd4; cursor: default; }
  .pag-info { font-size: 11.5px; color: #8a939c; }
  .acoes-sep { width: 1px; height: 32px; background: #dfe3e8; margin-right: 4px; }

  .btn-passo {
    display: inline-flex; align-items: center; gap: 9px; text-align: left;
    padding: 6px 14px 6px 9px; border-radius: 6px; cursor: pointer; font-size: 13px; line-height: 1.15;
    transition: background .12s, border-color .12s, box-shadow .12s;
  }
  .btn-passo .passo-n {
    flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center;
    width: 20px; height: 20px; border-radius: 50%;
    font-family: 'IBM Plex Mono', Consolas, monospace; font-size: 11px; font-weight: 700;
  }
  .btn-passo .passo-txt { display: flex; flex-direction: column; }
  .btn-passo .passo-txt b { font-weight: 600; white-space: nowrap; }
  .btn-passo .passo-txt small { font-size: 10.5px; margin-top: 1px; white-space: nowrap; }

  .passo-1 { background: #1ab394; border: 1px solid #1ab394; color: #fff; box-shadow: 0 1px 2px rgba(16,24,40,.14); }
  .passo-1:hover, .passo-1:focus { background: #18a689; border-color: #18a689; color: #fff; }
  .passo-1 .passo-n { background: rgba(255,255,255,.24); color: #fff; }
  .passo-1 .passo-txt small { color: rgba(255,255,255,.88); }

  .passo-1[disabled] { background: #cfd6dc; border-color: #cfd6dc; color: #fff; box-shadow: none; cursor: default; }
  .passo-1[disabled]:hover { background: #cfd6dc; border-color: #cfd6dc; }

  .passo-2, .passo-3 { background: #fff; border: 1px solid #1ab394; color: #12876f; }
  .passo-2:hover, .passo-2:focus, .passo-2.aberto, .passo-3:hover, .passo-3:focus { background: #f2fbf8; color: #12876f; }
  .passo-2 .passo-n, .passo-3 .passo-n { background: #e4f6f1; color: #12876f; }
  .passo-2 .passo-txt small, .passo-3 .passo-txt small { color: #7b8b87; }
  .passo-2 { background: #f3f8fd; border-color: #1c84c6; color: #15699f; }
  .passo-2:hover, .passo-2:focus, .passo-2.aberto { background: #e6f1fa; border-color: #1c84c6; color: #15699f; }
  .passo-2 .passo-n { background: #d7e8f6; color: #15699f; }
  .passo-2 .passo-txt small { color: #6e8aa3; }
  .passo-2 .passo-caret { color: #6e8aa3; }
  .passo-2[disabled], .passo-3[disabled] { opacity: .65; cursor: default; background: #fff; }
  .passo-caret { font-size: 11px; margin-left: 2px; color: #7b8b87; }

  .passo-drop { position: relative; }
  .passo-menu-fundo { position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 1090; }
  .passo-menu { position: absolute; bottom: calc(100% + 6px); left: 0; min-width: 340px; background: #fff; border: 1px solid #d3d8de; border-radius: 6px; box-shadow: 0 6px 20px rgba(16,24,40,.16); overflow: hidden; z-index: 1100; }
  .passo-menu a { display: block; padding: 10px 14px; font-size: 13px; color: #1c2024; border-bottom: 1px solid #eef1f4; text-decoration: none; }
  .passo-menu a:last-child { border-bottom: none; }
  .passo-menu a:hover { background: #f4f6f8; }
  .passo-menu a i { width: 18px; color: #12876f; }
  .passo-menu a b { font-weight: 600; }
  .passo-menu a small { display: block; color: #8a939c; font-size: 11.5px; margin-left: 22px; }

  .passo-seta { color: #b9c1c9; font-size: 16px; }

  .tabela-ibox { margin-top: -16px; }
  .tabela-conc { margin-bottom: 0; }
  .tabela-conc thead th {
    position: sticky; top: 0; z-index: 2;
    background: #f7f9fa; color: #7b848e; font-weight: 600; font-size: 10.5px; text-transform: uppercase; letter-spacing: .05em;
    border-bottom: 1px solid #dfe3e8 !important; border-top: none; padding: 8px 9px; white-space: nowrap;
  }
  .tabela-conc tbody td { vertical-align: middle; padding: 9px 8px; border-top: 1px solid #f0f1f3; }
  .tabela-conc tbody tr:nth-child(even) > td { background: #fbfcfd; }
  .tabela-conc tbody tr:hover > td { background: #eaf5ff !important; }
  .tabela-conc .nowrap { white-space: nowrap; }
  .tabela-conc .col-projeto { font-weight: 600; color: #1a2035; }
  .tabela-conc .col-banco { font-size: 12.5px; max-width: 190px; }
  .tabela-conc .col-banco .mono { color: #34495e; }
  .tabela-conc .sep { border-left: 1px solid #e6e9ed; }
  .tabela-conc .sep-r { border-right: 1px solid #e6e9ed; }
  .tabela-conc .num { font-family: 'IBM Plex Mono', Consolas, monospace; font-variant-numeric: tabular-nums; white-space: nowrap; font-size: 13px; color: #1a2035; }
  .tabela-conc .num .sub { display: block; font-family: 'Open Sans', sans-serif; font-size: 11px; color: #8a939c; margin-top: 2px; white-space: nowrap; font-weight: 400; }
  .tabela-conc .num .ok { color: #0a6d4d; }
  .tabela-conc .num .neg { color: #c0392b; font-weight: 600; }
  .tabela-conc .num .pend-val { color: #b06a15; font-weight: 600; }
  .tabela-conc .num .sub.sub-op { color: #b06a15; font-weight: 600; cursor: help; }
  .tabela-conc .num .mudo { color: #b3b9c0; }
  .tabela-conc .num .div-cel { display: inline-flex; align-items: center; justify-content: flex-end; gap: 5px; }
  .tabela-conc .num .div-vermelho { color: #c0392b; }
  .tabela-conc .num .div-laranja { color: #d68a00; }
  .tabela-conc .num .div-roxo { color: #5b3a9e; }
  .tabela-conc .col-usuario { display: inline-block; max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: bottom; }

  .seg-situacao { display: flex; width: 100%; border: 1px solid #c7cdd4; border-radius: 5px; overflow: hidden; height: 34px; }
  .seg-situacao button { flex: 1; border: none; background: #fff; color: #5b6570; font-size: 13px; padding: 0 8px; cursor: pointer; border-left: 1px solid #e2e6ea; white-space: nowrap; }
  .seg-situacao button:first-child { border-left: none; }
  .seg-situacao button:hover { background: #f4f6f8; }
  .seg-situacao button.ativo { background: #1ab394; color: #fff; font-weight: 600; }

  .tag-encerrada { display: inline-block; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .3px; color: #c0392b; background: #fdecec; border: 1px solid #f5c6c6; border-radius: 10px; padding: 1px 8px; margin-left: 6px; vertical-align: middle; }
  .tag-transitoria { display: inline-block; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .3px; color: #8a5a00; background: #fdf3e0; border: 1px solid #f0d9a8; border-radius: 10px; padding: 1px 8px; margin-left: 6px; vertical-align: middle; }

  .badge-status { display: inline-flex; align-items: center; gap: 6px; padding: 6px 13px; border-radius: 14px; font-size: 12px; font-weight: 600; line-height: 1; }
  .badge-ok { background: #e5f7f0; color: #18a689; }
  .badge-andamento { background: #fff4e0; color: #d68a00; }
  .badge-no { background: #fdecec; color: #e05a5a; }

  .pendencias { font-size: 16px; font-weight: 700; color: #34495e; line-height: 1.1; }
  .pendencias.pend-zero { color: #b3b9c0; font-weight: 500; }

  .barra-conc { height: 14px; border-radius: 7px; background: #eceef1; overflow: hidden; }
  .barra-conc > span { display: block; height: 100%; border-radius: 7px; transition: width .3s; }
  .barra-legenda { margin-top: 5px; font-size: 12px; }
  .barra-legenda .dot { display: inline-block; width: 9px; height: 9px; border-radius: 50%; margin-right: 5px; vertical-align: middle; }
  .barra-legenda strong { font-size: 13px; }

  .btn-abrir { height: 30px; padding: 0 12px; font-size: 12.5px; font-weight: 600; border-radius: 4px; }
  .btn-abrir .fa { margin-left: 4px; transition: transform .15s; }
  .btn-abrir:hover .fa { transform: translateX(3px); }

  .conc-ov { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(16,24,40,.55); z-index: 2000; display: flex; align-items: center; justify-content: center; }
  .conc-modal { background: #fff; border-radius: 8px; max-width: 92vw; box-shadow: 0 16px 48px rgba(16,24,40,.35); }

  .conc-modal.proc-modal { width: 620px; max-width: 96vw; }
  .proc-head { padding: 14px 18px; border-bottom: 1px solid #eceef1; }
  .proc-head h4 { margin: 0; font-size: 16px; font-weight: 600; }
  .proc-sub { display: block; color: #8a939c; font-size: 12px; margin-top: 3px; }
  .proc-corpo { padding: 14px 18px; max-height: 62vh; overflow: auto; }
  .proc-carregando { text-align: center; padding: 26px 10px; color: #8a939c; }
  .proc-cards { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
  .proc-card { background: #f7f9fa; border: 1px solid #e6e9ed; border-radius: 7px; padding: 10px 13px; }
  .proc-lbl { font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; }
  .proc-num { font-family: 'IBM Plex Mono', Consolas, monospace; font-variant-numeric: tabular-nums; font-size: 21px; font-weight: 600; color: #1c2024; margin-top: 3px; }
  .proc-txt { font-size: 13px; color: #2a3038; margin-top: 5px; }
  .proc-obs { font-size: 11.5px; color: #8a939c; margin-top: 3px; }
  .proc-sug { margin-top: 12px; padding: 10px 13px; border-radius: 7px; background: #fdf8ec; border: 1px solid #f0dfb0; }
  .proc-sug-tit { font-size: 13px; font-weight: 600; color: #8a5a00; margin-bottom: 4px; }
  .proc-sug-txt { font-size: 12px; color: #6b5a33; margin-bottom: 8px; }
  .proc-sug-item { display: flex; align-items: flex-start; gap: 6px; padding: 6px 0; border-top: 1px solid #f3e7c6; }
  .proc-sug-campo { flex: 1 1 auto; min-width: 0; }
  .proc-sug-campo small { display: block; margin-top: 2px; font-size: 11px; color: #8a7a55; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .proc-sug-item .btn { flex: 0 0 auto; margin-top: 3px; }
  .proc-auto { margin-top: 12px; padding: 10px 13px; border-radius: 7px; font-size: 12.5px; display: flex; flex-direction: column; gap: 4px; }
  .proc-auto b { font-size: 13px; }
  .proc-auto.auto-on { background: #eef9f4; border: 1px solid #bde5d5; color: #0a6d4d; }
  .proc-auto.auto-off { background: #f7f9fa; border: 1px solid #e6e9ed; color: #5b6570; }
  .proc-auto span { color: #4a545e; }
  .proc-alerta { margin-top: 12px; padding: 10px 13px; border-radius: 7px; background: #fdf9ef; border: 1px solid #f0d9a8; color: #8a5a00; font-size: 12.5px; }
  .proc-progresso { margin-top: 12px; padding: 10px 13px; border-radius: 7px; background: #f2f7fd; border: 1px solid #cfe0f2; color: #2b5b8c; font-size: 12.5px; }
  .proc-progresso.proc-fim { background: #eef9f4; border-color: #bde5d5; color: #0a6d4d; }
  .proc-avisos { margin-top: 12px; border: 1px solid #f0d9a8; background: #fffdf7; border-radius: 7px; padding: 10px 13px; }
  .proc-desfeitos { border-color: #e6b8b2; background: #fff8f7; }
  .proc-desfeitos .proc-avisos-tit { color: #9b3428; }
  .proc-avisos-tit { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .05em; color: #8a5a00; }
  .proc-avisos ul { margin: 6px 0 0; padding-left: 18px; }
  .proc-avisos li { font-size: 12.5px; color: #4a545e; margin-bottom: 3px; }
  .proc-foot { display: flex; justify-content: flex-end; gap: 8px; align-items: center; padding: 12px 18px; border-top: 1px solid #eceef1; }

  .env-bloqueio { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; padding: 10px 12px; border: 1px solid #f0d0a0; border-radius: 6px; background: #fdf6e7; color: #8a6d3b; font-size: 12px; }
  .env-bloqueio .fa { font-size: 16px; }
  .conc-modal.env-modal { width: 640px; max-width: 96vw; }
  .env-head { display: flex; justify-content: space-between; align-items: flex-start; padding: 14px 18px; border-bottom: 1px solid #eceef1; }
  .env-head h4 { margin: 0; font-size: 16px; font-weight: 600; }
  .env-sub { display: block; color: #8a939c; font-size: 12px; margin-top: 3px; }
  .env-corpo { padding: 14px 18px; }
  .env-vazio { text-align: center; padding: 26px 10px; color: #8a939c; }
  .env-vazio-ic { font-size: 40px; color: #c7cdd4; }
  .env-vazio-t { margin: 12px 0 4px; font-size: 14px; font-weight: 600; color: #5b6570; }
  .env-vazio-s { margin: 0; font-size: 12.5px; }
  .env-topo { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
  .env-check { font-weight: 600; font-size: 13px; color: #3b444d; margin: 0; cursor: pointer; }
  .env-check input { margin-right: 6px; }
  .env-cont { font-size: 12px; color: #8a939c; }
  .env-lista { max-height: 46vh; overflow: auto; border: 1px solid #eceef1; border-radius: 6px; }
  .env-item { display: flex; align-items: center; gap: 10px; padding: 9px 12px; margin: 0; font-weight: normal; border-bottom: 1px solid #f2f3f5; cursor: pointer; }
  .env-grupo:last-child .env-item:last-child { border-bottom: none; }
  .env-grupo-cab { position: sticky; top: 0; z-index: 1; display: flex; align-items: center; gap: 8px; padding: 8px 12px; margin: 0; background: #f4f6f8; border-bottom: 1px solid #e6e9ed; cursor: pointer; }
  .env-grupo-cab.sel { background: #e3f4ec; }
  .env-grupo-cab input { margin: 0; }
  .env-grupo-badge { display: inline-flex; align-items: center; gap: 6px; padding: 2px 9px; border: 1px solid; border-radius: 12px; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; line-height: 1.4; }
  .env-grupo-badge .fa { font-size: 11px; }
  .env-grupo-qtd { margin-left: auto; font-size: 11.5px; color: #8a939c; }
  .env-item.env-item-grupo { padding-left: 32px; }
  .env-item:hover { background: #f7f9fa; }
  .env-item.sel { background: #eef9f4; }
  .env-item input { margin: 0; }
  .env-tipo { flex: none; min-width: 38px; text-align: center; font-size: 9px; font-weight: 700; letter-spacing: .3px; border: 1px solid; border-radius: 4px; padding: 3px 5px; }
  .env-tipo-pdf { color: #c0392b; background: #fdecec; border-color: #f5c6c6; }
  .env-tipo-excel { color: #1d6f42; background: #e6f4ec; border-color: #b7dfc7; }
  .env-tipo-ofx { color: #5b4bb7; background: #efedfb; border-color: #d3cdf2; }
  .env-tipos { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 8px; }
  .env-tipo-check { display: inline-flex; align-items: center; gap: 6px; margin: 0; padding: 5px 10px; font-size: 12px; font-weight: 600; color: #3b444d; border: 1px solid #e6e9ed; border-radius: 6px; background: #fff; cursor: pointer; }
  .env-tipo-check.sel { background: #e3f4ec; border-color: #b7dfc7; }
  .env-tipo-check input { margin: 0; }
  .env-tipo-check .env-grupo-qtd { margin-left: 4px; }
  .env-subgrupo-cab { display: flex; align-items: center; gap: 8px; padding: 6px 12px; margin: 0; font-weight: normal; background: #fafbfc; border-bottom: 1px solid #f2f3f5; cursor: pointer; }
  .env-subgrupo-cab.sel { background: #eef8f3; }
  .env-subgrupo-cab input { margin: 0; }
  .env-subgrupo-cab.env-item-grupo { padding-left: 32px; }
  .env-item.env-item-subgrupo { padding-left: 32px; }
  .env-item.env-item-grupo.env-item-subgrupo { padding-left: 52px; }
  .env-nome { font-size: 13px; color: #2a3038; word-break: break-all; min-width: 0; }
  .env-pasta-cab { display: flex; align-items: center; gap: 6px; padding: 9px 14px 5px 18px; font-size: 13px; color: #7d8790; background: #fff; }
  .env-pasta-cab.env-item-grupo { padding-left: 32px; }
  .env-pasta-cab.env-item-grupo.env-item-subgrupo { padding-left: 52px; }
  .env-pasta-cab > .fa-folder-open-o { color: #a7b2bd; font-size: 14px; margin-right: 2px; }
  .env-pasta-dia { color: #4b545e; font-weight: 600; }
  .env-sep { font-size: 12px; color: #c3cad1; }
  .env-arquivo { font-weight: 600; color: #1c2024; }
  .env-item.falhou { background: #fdf6ec; }
  .env-item.falhou:hover { background: #fbf0dd; }
  .env-item.falhou.sel { background: #f7efe0; }
  .env-aviso { display: block; margin-top: 3px; font-size: 11px; color: #b06a15; }
  .env-aviso .fa { margin-right: 4px; }
  .env-foot { display: flex; justify-content: space-between; align-items: center; padding: 12px 18px; border-top: 1px solid #eceef1; }
  .env-foot-r { display: flex; gap: 8px; }
  .passo-1.passo-andamento { background-color: #fff; border-color: #1ab394; color: #12876f; box-shadow: none; animation: passo-respira 2.4s ease-in-out infinite; }
  .passo-1.passo-andamento:hover, .passo-1.passo-andamento:focus { background-color: #fff; border-color: #18a689; color: #0f7560; }
  .passo-1.passo-andamento .passo-n { background: #1ab394; color: #fff; }
  .passo-1.passo-andamento .passo-txt small { color: #4f8f80; }
  .passo-1.passo-andamento .passo-txt small u { color: #12876f; }
  .passo-1 .passo-pct { display: inline-block; margin-left: 4px; padding: 0 6px; border-radius: 8px; background: #1ab394; color: #fff; font-size: 11px; }
  .passo-1.passo-destaque { animation: passo-chegou .65s ease-out 0s 4; }
  .passo-1.passo-feito { background: #18a689; border-color: #18a689; animation: passo-chegou .65s ease-out 0s 2; }
  .passo-1.passo-falhou { background: #d9534f; border-color: #d9534f; animation: passo-chegou .65s ease-out 0s 2; }
  @keyframes passo-respira { 0%, 100% { box-shadow: 0 0 0 0 rgba(26,179,148,.35); } 50% { box-shadow: 0 0 0 5px rgba(26,179,148,0); } }
  @keyframes passo-chegou { 0% { box-shadow: 0 0 0 0 rgba(26,179,148,.7); transform: scale(1); } 40% { transform: scale(1.06); } 100% { box-shadow: 0 0 0 14px rgba(26,179,148,0); transform: scale(1); } }
  .btn-sair { background: #fdf1f1; border: 1px solid #e4d7d7; color: #a13c3c; font-weight: 600; }
  .btn-sair:hover { background: #fbe7e7; border-color: #d9c2c2; color: #a13c3c; }
  .btn-aplic { display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; margin-left: 6px; vertical-align: middle; border-radius: 4px; border: 1px solid #dfe3e8; background: #fff; color: #8a939c; font-size: 12.5px; cursor: pointer; }
  .btn-aplic:hover { border-color: #1ab394; color: #12876f; background: #f2fbf8; }
  .btn-aplic-vazio, .btn-aplic-vazio:hover { visibility: hidden; cursor: default; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/ConciliacaoBancoLista.vue